/* Acumen PDP behaviour — seat estimator, size chart modal, Design your table
   CTA scroll-to-BCPO, sticky ATC. All feature-detected so a missing element
   never throws — safe alongside Impulse's own variant JS and BCPO's app-embed. */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function toInt(v) {
    var n = parseInt(String(v || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  // ─────────── Read the currently selected variant options ───────────
  // Impulse's dropdown variant picker wraps each Shopify option in
  // `.variant-wrapper` with a `<label>` naming the option ("TABLE LENGTH")
  // and a `<select data-index="optionN">`. Button-style picker uses
  // `.selector-wrapper` with a legend + radios. Cover both.
  function readOptionInfos(scope) {
    var out = [];
    scope.querySelectorAll('.variant-wrapper, .selector-wrapper').forEach(function (w) {
      var lblEl = w.querySelector(':scope > label, legend, .single-option-selector-label, .form__label');
      if (!lblEl) {
        // Some variants nest the label deeper; take the first label if any.
        lblEl = w.querySelector('label');
      }
      if (!lblEl) return;
      // Strip nested trailing colon text and any child spans.
      var name = (lblEl.childNodes[0] && lblEl.childNodes[0].textContent || lblEl.textContent).replace(/:\s*$/, '').trim();
      var val = null;
      var sel = w.querySelector('select[data-index]') || w.querySelector('select.single-option-selector') || w.querySelector('select');
      if (sel && sel.value) val = sel.value;
      if (!val) {
        var radio = w.querySelector('input[type="radio"]:checked');
        if (radio) val = radio.value;
      }
      if (name) out.push({ name: name, value: val });
    });
    return out;
  }

  // ─────────── Seat estimator ───────────
  // Reads the current variant's options and looks for length + width by
  // keyword match ("length" / "long", "width" / "wide"). Hidden if either is
  // missing — safe on products that don't have both dimensions as variants.
  function readCurrentDims(scope) {
    var infos = readOptionInfos(scope);
    if (!infos.length) return null;
    var dims = { length: 0, width: 0 };
    for (var i = 0; i < infos.length; i++) {
      var n = (infos[i].name || '').toLowerCase();
      var v = infos[i].value;
      if (v == null) continue;
      var cm = toInt(v);
      if (!cm) continue;
      if (n.indexOf('length') > -1 || n.indexOf('long') > -1) dims.length = cm;
      else if (n.indexOf('width') > -1 || n.indexOf('wide') > -1) dims.width = cm;
    }
    return (dims.length && dims.width) ? dims : null;
  }

  // Thickness chip is a fixed 45 mm spec rendered by Liquid — no JS needed.

  function endChairsPerEnd(W) { return (W >= 132) ? 2 : 1; }

  function seatsRange(L, W) {
    var minSide = Math.floor(L / 65) * 2;
    var maxSide = Math.floor(L / 50) * 2;
    // End chairs from 180cm — owner sign-off 8 Sep 2026 (180x110 = 6-8 seater).
    var ends = (L >= 180) ? endChairsPerEnd(W) * 2 : 0;
    return { min: minSide + ends, max: maxSide + ends };
  }

  function updateSeatBadge(scope) {
    var badge = scope.querySelector('[data-acumen-seats]');
    if (!badge) return;
    var dims = readCurrentDims(scope);
    if (!dims) {
      badge.hidden = true;
      return;
    }
    var r = seatsRange(dims.length, dims.width);
    if (r.max <= 0) { badge.hidden = true; return; }
    var label = (r.min === r.max) ? String(r.min) : (r.min + '–' + r.max);
    var num = badge.querySelector('[data-role="seat-num"]');
    var txt = badge.querySelector('[data-role="seat-text"]');
    if (num) num.textContent = label;
    if (txt) txt.textContent = label;
    badge.hidden = false;
  }

  // ─────────── Size chart modal ───────────
  function drawTable(L, W) {
    var scale = 0.55;
    var tW = L * scale;
    var tH = W * scale;
    var chairLong = 40 * scale;
    var chairDeep = 12 * scale;
    var gap = 3;
    var pad = 6;

    var sideChairs = Math.floor(L / 50);
    var endChairs = (L >= 180) ? endChairsPerEnd(W) : 0;

    var canvasW = tW + 2 * (chairDeep + gap + pad);
    var canvasH = tH + 2 * (chairDeep + gap + pad);
    var tx = pad + chairDeep + gap;
    var ty = pad + chairDeep + gap;

    var uid = 'acsc-' + L + '-' + W;
    var svg = '<svg viewBox="0 0 ' + canvasW.toFixed(1) + ' ' + canvasH.toFixed(1) + '" width="' + canvasW.toFixed(1) + '" height="' + canvasH.toFixed(1) + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax meet">';
    svg += '<defs><linearGradient id="' + uid + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#b78a58"/><stop offset="1" stop-color="#6b4826"/></linearGradient></defs>';
    svg += '<rect x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '" width="' + tW.toFixed(1) + '" height="' + tH.toFixed(1) + '" fill="url(#' + uid + ')" stroke="#3a2612" stroke-width="0.8"/>';

    var sideSpacing = tW / sideChairs;
    for (var i = 0; i < sideChairs; i++) {
      var cx = tx + sideSpacing * (i + 0.5) - chairLong / 2;
      svg += '<rect x="' + cx.toFixed(1) + '" y="' + (ty - gap - chairDeep).toFixed(1) + '" width="' + chairLong.toFixed(1) + '" height="' + chairDeep.toFixed(1) + '" fill="#2f3a24" rx="1.5"/>';
      svg += '<rect x="' + cx.toFixed(1) + '" y="' + (ty + tH + gap).toFixed(1) + '" width="' + chairLong.toFixed(1) + '" height="' + chairDeep.toFixed(1) + '" fill="#2f3a24" rx="1.5"/>';
    }

    if (endChairs > 0) {
      var endSpacing = tH / endChairs;
      for (var j = 0; j < endChairs; j++) {
        var cy = ty + endSpacing * (j + 0.5) - chairLong / 2;
        svg += '<rect x="' + (tx - gap - chairDeep).toFixed(1) + '" y="' + cy.toFixed(1) + '" width="' + chairDeep.toFixed(1) + '" height="' + chairLong.toFixed(1) + '" fill="#2f3a24" rx="1.5"/>';
        svg += '<rect x="' + (tx + tW + gap).toFixed(1) + '" y="' + cy.toFixed(1) + '" width="' + chairDeep.toFixed(1) + '" height="' + chairLong.toFixed(1) + '" fill="#2f3a24" rx="1.5"/>';
      }
    }
    svg += '</svg>';
    var r = seatsRange(L, W);
    var seatLbl = (r.min === r.max) ? String(r.min) : (r.min + '–' + r.max);
    return { svg: svg, seats: seatLbl };
  }

  var CHART_GROUPS = [
    { title: '88 cm wide',  tag: 'Narrow — one chair each end from 180 cm',    W:  88, lengths: [150, 180, 210, 240, 270] },
    { title: '110 cm wide', tag: 'Standard — same seats as 88 cm',              W: 110, lengths: [180, 210, 240, 270, 300] },
    { title: '132 cm wide', tag: 'Wide — two chairs each end from 180 cm (+2)', W: 132, lengths: [210, 240, 270, 300] }
  ];

  // Elm doesn't ship 132cm — hide that row on elm PDPs. The modal wrapper
  // carries data-timber-type from the Liquid render (product.metafields.acumen.timber_type),
  // e.g. "Reclaimed Elm" | "Rustic Pine". Anything else falls through to full range.
  function groupsForTimber(timberType) {
    var t = String(timberType || '').toLowerCase();
    if (t.indexOf('elm') !== -1) {
      return CHART_GROUPS.filter(function (g) { return g.W !== 132; });
    }
    return CHART_GROUPS;
  }

  var chartRendered = false;
  function renderSizeChart(body) {
    if (chartRendered || !body) return;
    var modal = body.closest('[data-acumen-sizechart-modal]');
    var timber = modal ? modal.getAttribute('data-timber-type') : '';
    var groups = groupsForTimber(timber);
    var html = '';
    groups.forEach(function (g) {
      html += '<div class="acumen-sc-row">';
      html += '<div class="acumen-sc-row-head"><h3>' + g.title + '</h3><span>' + g.tag + '</span></div>';
      html += '<div class="acumen-sc-tables">';
      g.lengths.forEach(function (L) {
        var t = drawTable(L, g.W);
        html += '<figure class="acumen-sc-table">';
        html += '<div class="acumen-sc-svg">' + t.svg + '</div>';
        html += '<figcaption><b>' + L + ' × ' + g.W + '</b> cm<span>≈ ' + t.seats + ' seats</span></figcaption>';
        html += '</figure>';
      });
      html += '</div></div>';
    });
    body.innerHTML = html;
    chartRendered = true;
  }

  function wireSizeChart(scope) {
    var modal = document.querySelector('[data-acumen-sizechart-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-acumen-sizechart-body]');
    var closeBtn = modal.querySelector('[data-acumen-sizechart-close]');

    function open() {
      renderSizeChart(body);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    scope.querySelectorAll('[data-acumen-sizechart-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  // ─────────── "Design your table" CTA — scroll to BCPO options ───────────
  // BCPO injects its options container at runtime. Common selectors we try
  // (any hit wins): #bcpo-container, [id^="bcpo"], .bcpo-container,
  // .best-custom-product-options, or a fallback of the buy_buttons block.
  function findBcpoRoot() {
    // BCPO on Acumen's Impulse install renders as <div id="bcpo" class="bcpo">
    // injected directly into the product form. Try that first, then broader
    // fallbacks for other product template variants.
    var candidates = [
      '#bcpo',
      '.bcpo',
      '#bcpo-container',
      '.bcpo-container',
      '.best-custom-product-options',
      '[id^="bcpo_wrap"]',
      '[id^="bcpo-"]',
      '[data-bcpo]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    // Fallback: scroll to buy buttons if we can't find BCPO
    return document.querySelector('[data-acumen-buy-buttons]');
  }

  function wireDesignCta(scope) {
    scope.querySelectorAll('[data-acumen-design-cta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = findBcpoRoot();
        if (!target) return;
        var offset = 80; // clear any sticky header
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  // ─────────── Sticky ATC bar ───────────
  // Slides up from the bottom when the main add-to-cart button scrolls out of
  // view. The button in the sticky bar submits the same form (or delegates a
  // click to the main add-to-cart button — safer since we don't want to submit
  // twice when BCPO intercepts).
  var STICKY_HINT = 'Design your table above', STICKY_NAME = 'Your table';
  function wireStickyAtc(scope) {
    STICKY_HINT = scope.getAttribute('data-sticky-hint') || STICKY_HINT;
    STICKY_NAME = scope.getAttribute('data-sticky-name') || STICKY_NAME;
    var buyBlock = scope.querySelector('[data-acumen-buy-buttons]');
    if (!buyBlock) return;
    var addBtn = buyBlock.querySelector('button[type="submit"], .btn--add-to-cart, [data-add-to-cart]');
    if (!addBtn) return;

    // Build the sticky bar once, appended to body so it can be truly full-width.
    var bar = document.createElement('div');
    bar.className = 'acumen-sticky-atc';
    bar.innerHTML =
      '<div class="acumen-sticky-inner">' +
        '<div class="acumen-sticky-title">' +
          '<div class="acumen-sticky-name" data-acumen-sticky-name></div>' +
          '<div class="acumen-sticky-hint" data-acumen-sticky-hint>' + STICKY_HINT + '</div>' +
        '</div>' +
        '<div class="acumen-sticky-price" data-acumen-sticky-price></div>' +
        '<button type="button" class="acumen-sticky-btn" data-acumen-sticky-btn>Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    // Fill title + price from the scope
    var titleEl = bar.querySelector('[data-acumen-sticky-name]');
    var priceEl = bar.querySelector('[data-acumen-sticky-price]');
    var stickyBtn = bar.querySelector('[data-acumen-sticky-btn]');
    var title = (scope.querySelector('.product-single__title') || {}).textContent || STICKY_NAME;
    if (titleEl) titleEl.textContent = title.trim();
    // When the sale-event coupon box is on the page ([data-coupon-price], a product-page block),
    // show its "coupon applied" price, with the normal price struck through; otherwise the normal price.
    function syncPrice() {
      if (!priceEl) return;
      var pEl = scope.querySelector('[data-product-price]');
      var cw = document.querySelector('[data-coupon-price]');
      var sEl = cw && cw.querySelector('[data-sale-price]');
      var sale = sEl ? (sEl.textContent || '').trim() : '';
      var reg = pEl ? (pEl.textContent || '').trim() : '';
      if (sale && sale !== reg) {
        priceEl.innerHTML = '<s class="acumen-sticky-was"></s> <span class="acumen-sticky-now"></span>';
        priceEl.querySelector('.acumen-sticky-was').textContent = reg;
        priceEl.querySelector('.acumen-sticky-now').textContent = sale;
      } else {
        priceEl.textContent = reg;
      }
    }
    syncPrice();
    document.addEventListener('variant:change', function () { setTimeout(syncPrice, 0); });
    // Fallback: MutationObservers for BCPO price changes and the coupon box re-rendering
    if ('MutationObserver' in window) {
      var pEl = scope.querySelector('[data-product-price]');
      if (pEl) new MutationObserver(function () { setTimeout(syncPrice, 0); }).observe(pEl, { characterData: true, childList: true, subtree: true });
      var watchCoupon = function () {
        var sEl = document.querySelector('[data-coupon-price] [data-sale-price]');
        if (!sEl) return false;
        new MutationObserver(syncPrice).observe(sEl, { characterData: true, childList: true, subtree: true });
        syncPrice();
        return true;
      };
      if (!watchCoupon()) { var tries = 0, t = setInterval(function () { if (watchCoupon() || ++tries > 25) clearInterval(t); }, 200); }
    }

    // Delegated click: fires a synthetic click on the real add-to-cart button
    // so anything Impulse/BCPO has bound to it fires normally.
    // The theme / options app can replace the add-to-cart button after load, so always
    // look up the one that is actually on the page rather than the one found at start-up.
    function liveAddBtn() {
      var block = document.querySelector('[data-acumen-buy-buttons]') || buyBlock;
      var list = block.querySelectorAll('button[type="submit"], .btn--add-to-cart, [data-add-to-cart]');
      for (var i = 0; i < list.length; i++) { if (list[i].getBoundingClientRect().height > 0) return list[i]; }
      return list[0] || addBtn;
    }

    // If the add is blocked (a required option missing), the app's message appears next to
    // the real button, off-screen. Bring it into view so the click never looks dead.
    function firstVisibleError() {
      var btn = liveAddBtn(), form = btn.form || document.querySelector('[data-acumen-buy-buttons]') || buyBlock;
      var els = form.querySelectorAll('[class*="error" i], [class*="required-message" i], .errors');
      for (var i = 0; i < els.length; i++) {
        var e = els[i], r = e.getBoundingClientRect();
        if (r.width && r.height && (e.textContent || '').trim()) return e;
      }
      return null;
    }
    stickyBtn.addEventListener('click', function () {
      liveAddBtn().click();
      setTimeout(function () {
        var err = firstVisibleError();
        if (!err) return;
        var y = err.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }, 250);
    });

    // Show the bar once the visitor has started scrolling and the real add-to-cart button
    // is off-screen (above or below). Watching the button itself — not the whole options
    // block — keeps the bar available while options are being chosen.
    var chatShifted = null;
    function shiftChat(on) {
      var c = document.querySelector('.helpdesk-channel-btn-show');
      var f = c;
      while (f && f !== document.body && getComputedStyle(f).position !== 'fixed') f = f.parentElement;
      if (!f || f === document.body) return;
      f.style.transition = 'transform .28s ease-out';
      f.style.transform = on ? 'translateY(-' + (bar.offsetHeight + 8) + 'px)' : '';
      chatShifted = on;
    }
    function updateBar() {
      var r = liveAddBtn().getBoundingClientRect();
      var btnInView = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 250;
      var on = scrolled && !btnInView;
      if (bar.classList.contains('is-on') !== on) {
        bar.classList.toggle('is-on', on);
        document.documentElement.classList.toggle('acumen-sticky-on', on);
      }
      if (chatShifted !== on) shiftChat(on);
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    setInterval(updateBar, 700);
    updateBar();

    // Wire the choices-remaining counter — watches BCPO for changes.
    watchChoicesRemaining(bar);
  }

  // ─────────── Choices remaining counter ───────────
  // Counts BCPO option groups the customer is expected to answer, and shows
  // how many are still pending in the sticky ATC hint. Only VISIBLE groups
  // count — a conditional option hidden until a parent is selected doesn't
  // register until it becomes visible.
  function isVisible(el) {
    if (!el || !el.offsetParent) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  // Counts the QUESTIONS the customer must answer (not individual swatches/buttons):
  // radios are grouped by their name, and only groups the options app marks as required count,
  // plus the size/variant dropdowns. Optional extras (leaves, edge profile, delivery day…) don't count.
  function countChoices() {
    var bcpo = document.querySelector('#bcpo');
    if (!bcpo) return { total: 0, done: 0 };
    var groups = {};
    var fields = bcpo.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.type === 'hidden' || f.disabled) continue;
      // visible = the field or its label is on the page (radios themselves are often visually hidden)
      var lab = f.id ? bcpo.querySelector('label[for="' + f.id + '"]') : null;
      if (!isVisible(f) && !(lab && isVisible(lab)) && !isVisible(f.parentElement)) continue;
      var isVariantSelect = f.tagName === 'SELECT' && /^bcpo-select-option-/.test(f.id || '');
      var required = f.required || f.getAttribute('aria-required') === 'true' || isVariantSelect;
      var key = (f.type === 'radio' || f.type === 'checkbox') && f.name ? 'n:' + f.name : 'e:' + (f.id || f.name || i);
      var g = groups[key] || (groups[key] = { required: false, done: false });
      if (required) g.required = true;
      if (f.type === 'radio' || f.type === 'checkbox') { if (f.checked) g.done = true; }
      else if ((f.value || '').trim()) g.done = true;
    }
    var total = 0, done = 0;
    for (var k in groups) { if (!groups[k].required) continue; total++; if (groups[k].done) done++; }
    return { total: total, done: done };
  }

  function updateStickyHint(bar) {
    if (!bar) return;
    var hint = bar.querySelector('[data-acumen-sticky-hint]');
    if (!hint) return;
    var c = countChoices();
    if (c.total === 0) {
      hint.textContent = STICKY_HINT;
      bar.classList.remove('is-done');
      return;
    }
    var left = c.total - c.done;
    if (left <= 0) {
      hint.textContent = 'Ready to add to cart';
      bar.classList.add('is-done');
    } else {
      hint.textContent = left + (left === 1 ? ' required choice left' : ' required choices left');
      bar.classList.remove('is-done');
    }
  }

  function watchChoicesRemaining(bar) {
    var run = function () { updateStickyHint(bar); };
    run();
    // Watch BCPO for selection changes.
    var bcpo = document.querySelector('#bcpo');
    if (bcpo && 'MutationObserver' in window) {
      new MutationObserver(function () {
        // Debounce a hair — BCPO can fire many mutations in one interaction.
        clearTimeout(watchChoicesRemaining._t);
        watchChoicesRemaining._t = setTimeout(run, 40);
      }).observe(bcpo, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'value'] });
    }
    // Also listen for input/change events at the document level (BCPO uses both).
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('#bcpo')) run();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#bcpo')) setTimeout(run, 30);
    });
    // Retry after BCPO's initial render if it hadn't rendered on first pass.
    // The options app can render late (the theme defers scripts until first interaction),
    // so keep looking for up to a minute and attach the watcher when it appears.
    var tries = 0, attached = !!bcpo;
    var boot = setInterval(function () {
      tries++;
      var b = document.querySelector('#bcpo');
      if (b) {
        if (!attached && 'MutationObserver' in window) {
          attached = true;
          new MutationObserver(function () {
            clearTimeout(watchChoicesRemaining._t);
            watchChoicesRemaining._t = setTimeout(run, 40);
          }).observe(b, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'value'] });
        }
        run();
        clearInterval(boot);
      } else if (tries >= 120) {
        clearInterval(boot);
      }
    }, 500);
  }

  // ─────────── Reposition extras/CTA below the size options ───────────
  // Extras block (thickness chip / seats badge / size chart trigger) needs
  // to sit BELOW the size selectors — the seats badge live-reads the length
  // and width, so it's useless above the dropdowns. Anchors we try, in
  // priority order (last-in-DOM wins):
  //   1. BCPO's "REQUIRE A CUSTOM TABLE SIZE?" / "Exact LENGTH" / "Exact WIDTH"
  //   2. Shopify variant wrappers (TABLE LENGTH / WIDTH / THICKNESS)
  // BCPO consolidation can shuffle these into its #bcpo container long after
  // page load, so we run continuously for a while — MutationObserver plus
  // an interval fallback to catch races.
  function findLastSizeAnchor() {
    // Anchor: the LAST Shopify variant-wrapper (TIMBER THICKNESS on this
    // product). Not the BCPO size options — those bring recommendation
    // text and the Custom Size question that should sit BELOW our extras.
    var wrappers = document.querySelectorAll('.variant-wrapper');
    if (!wrappers.length) return null;
    // Pick the one that appears visually last, in case BCPO reorders them.
    var lastAnchor = null;
    var lastY = -Infinity;
    wrappers.forEach(function (a) {
      var r = a.getBoundingClientRect();
      var y = r.top + window.pageYOffset;
      if (y > lastY) { lastY = y; lastAnchor = a; }
    });
    return lastAnchor;
  }

  function relocateExtras() {
    var extras = document.querySelector('[data-acumen-extras]');
    var cta = document.querySelector('.acumen-cta-block');
    if (!extras || !cta) return false;
    var anchor = findLastSizeAnchor();
    if (!anchor) return false;
    // Put the extras INSIDE the last variant-wrapper (TIMBER THICKNESS) as
    // its last child. That way when BCPO moves the wrapper, extras moves
    // with it — no more positioning fights.
    var extrasInPlace = extras.parentElement === anchor && anchor.lastElementChild === extras;
    if (!extrasInPlace) {
      anchor.appendChild(extras);
    }
    // CTA sits as the sibling immediately after the wrapper — reads as "next step".
    if (anchor.nextElementSibling !== cta) {
      anchor.insertAdjacentElement('afterend', cta);
    }
    return true;
  }

  function watchExtrasPosition() {
    // Run immediately, then keep an eye on it — BCPO's consolidation can
    // fire late, and later variant/BCPO interactions can re-shuffle the
    // DOM. Cost of the polling is negligible; we bail out of the actual
    // move via a fast idempotency check when position is already right.
    relocateExtras();

    // MutationObserver — fires immediately on any DOM change in the meta
    // column, cheapest signal we have.
    if ('MutationObserver' in window) {
      var scope = document.querySelector('.product-single__meta') || document.body;
      var mo = new MutationObserver(function (records) {
        // Ignore mutations that we caused ourselves (extras move triggers
        // a childList mutation; we don't want an infinite ping-pong).
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'childList') {
            var moved = [].concat([].slice.call(r.addedNodes), [].slice.call(r.removedNodes));
            var self = moved.some(function (n) {
              return n && n.classList && (n.classList.contains('acumen-buy-extras') || n.classList.contains('acumen-cta-block'));
            });
            if (self) continue;
          }
          clearTimeout(watchExtrasPosition._d);
          watchExtrasPosition._d = setTimeout(relocateExtras, 30);
          return;
        }
      });
      mo.observe(scope, { childList: true, subtree: true });
      // Runs for the lifetime of the page — BCPO can re-shuffle late.
    }

    // Belt-and-braces interval — 500ms polling for the first two minutes
    // (catches slow BCPO races), then 2s slow-poll indefinitely so late
    // BCPO changes still get fixed.
    var fastTries = 0;
    var fastIv = setInterval(function () {
      fastTries++;
      relocateExtras();
      if (fastTries >= 240) {   // 240 × 500ms = 2 min
        clearInterval(fastIv);
        setInterval(relocateExtras, 2000);
      }
    }, 500);
  }

  // ─────────── Timber picker relocation + hover prefetch ───────────
  // Snippet renders the picker inside data-product-blocks near the top;
  // we move it to sit directly ABOVE the first .variant-wrapper (TABLE
  // LENGTH), following the same pattern that keeps the seats badge glued
  // to the size cluster. Hover prefetch warms the sibling page cache so
  // the swap feels near-instant when the customer clicks the other chip.
  function relocateTimberPicker() {
    var picker = document.querySelector('[data-acumen-timber-picker]');
    if (!picker) return false;
    // Scope the target search to the same buy-zone container as the picker's
    // current home so we ignore stray .variant-wrapper elements in unrelated
    // sections further down the page.
    var buyZone = picker.closest('[data-product-blocks], .product-single__meta, .product-form, .product-single__container') || document;
    var firstWrapper = buyZone.querySelector('.variant-wrapper');
    if (!firstWrapper) return true; // No target — leave picker at Liquid home.
    if (firstWrapper.previousElementSibling === picker) return true; // Already in the right spot.
    // Only relocate UP, never DOWN. On PDPs like Urban the variant_picker
    // block is positioned at the top of block_order and the picker's Liquid
    // home is above the size selectors — moving it before those selectors
    // would be a downward jump that buries the picker at the bottom of the
    // options list. We only reposition if the target sits BEFORE the picker
    // in DOM order (i.e. picker currently below its intended anchor).
    var rel = picker.compareDocumentPosition(firstWrapper);
    if (rel & Node.DOCUMENT_POSITION_FOLLOWING) {
      // firstWrapper comes AFTER picker in DOM — picker is already higher; leave it.
      return true;
    }
    firstWrapper.insertAdjacentElement('beforebegin', picker);
    return true;
  }

  function wireTimberPickerPrefetch() {
    var links = document.querySelectorAll('[data-acumen-timber-link]');
    links.forEach(function (link) {
      // On hover / touch-start / focus, ensure the target is in cache.
      // Prefetch tag already exists from Liquid; this is a belt-and-braces
      // second hint in case the browser dropped the prefetch.
      var warmed = false;
      var warm = function () {
        if (warmed) return;
        warmed = true;
        var pf = document.createElement('link');
        pf.rel = 'prefetch';
        pf.as = 'document';
        pf.href = link.getAttribute('href');
        document.head.appendChild(pf);
      };
      link.addEventListener('mouseenter', warm, { once: true });
      link.addEventListener('touchstart', warm, { once: true, passive: true });
      link.addEventListener('focus', warm, { once: true });
      // On click, mark the clicked chip as loading so the customer sees
      // immediate visual feedback while the sibling page loads.
      link.addEventListener('click', function () {
        link.classList.add('is-loading');
      });
    });
  }

  function watchTimberPicker() {
    relocateTimberPicker();
    wireTimberPickerPrefetch();
    // BCPO's consolidation can shift variant-wrappers late — same
    // observer pattern as the extras block. Fires cheaply, bails via
    // idempotency guard.
    if (!('MutationObserver' in window)) return;
    var scope = document.querySelector('.product-single__meta') || document.body;
    var mo = new MutationObserver(function () {
      clearTimeout(watchTimberPicker._d);
      watchTimberPicker._d = setTimeout(relocateTimberPicker, 30);
    });
    mo.observe(scope, { childList: true, subtree: true });
    // Slow poll indefinitely for the tail case where BCPO re-renders after page load.
    setInterval(relocateTimberPicker, 2000);
  }

  // Rustic ↔ Modern swap moved to BCPO native conditional: each COLOUR option
  // is now conditional on the TIMBER STYLE Shopify variant value, so BCPO
  // shows/hides the correct swatch and slab set on its own. JS in-place URL
  // rewriting would corrupt the hidden branch — removed.

  // ─────────── Timber-style preview (Rustic / Modern image swap) ───────────
  // The TIMBER STYLE Shopify variant is rendered by BCPO as
  // [data-unique="2"] with two radios (name="name2"). We show a preview
  // image beneath it that mirrors the current selection so customers see
  // the surface difference immediately. Preview markup is rendered by
  // snippets/acumen-timber-picker.liquid (starts hidden inside the
  // picker); this function relocates it to sit under the TIMBER STYLE
  // wrapper and wires the radios.
  function wireTimberStylePreview(scope) {
    var preview = document.querySelector('[data-acumen-timber-style-preview]');
    if (!preview) return;

    function findStyleVariantWrap() {
      // BCPO tags Shopify variant option 2 with data-unique="2".
      // Fall back to searching label text if that fails on some layout.
      var w = document.querySelector('[data-unique="2"]');
      if (w) return w;
      var wraps = document.querySelectorAll('.selector-wrapper');
      for (var i = 0; i < wraps.length; i++) {
        if (/timber style/i.test(wraps[i].textContent || '')) return wraps[i];
      }
      return null;
    }

    function place() {
      var wrap = findStyleVariantWrap();
      if (!wrap) return false;
      // Only move once; further calls are cheap no-ops.
      if (preview.previousElementSibling === wrap) return true;
      wrap.parentNode.insertBefore(preview, wrap.nextSibling);
      preview.hidden = false;
      return true;
    }

    function currentStyleValue() {
      // 1. Radio-rendered variant selector — BCPO name convention.
      var checked = document.querySelector('input[name="name2"]:checked');
      if (checked && checked.value) return String(checked.value).trim();
      // 2. Select-rendered variant selector — either inside the BCPO
      //    data-unique="2" wrapper, or a native Impulse selector whose
      //    for-label reads "TIMBER STYLE" / "Timber Style".
      var wrap = findStyleVariantWrap();
      if (wrap) {
        var sel = wrap.querySelector('select');
        if (sel && sel.value) return String(sel.value).trim();
        var chk = wrap.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (chk && chk.value) return String(chk.value).trim();
      }
      // 3. Fallback — any select whose associated label mentions timber style.
      var selects = document.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var lbl = selects[i].closest('.selector-wrapper, .variant-wrapper, .product-form__item, [data-variant-input]');
        if (lbl && /timber\s*style/i.test(lbl.textContent || '')) return String(selects[i].value || '').trim();
      }
      return '';
    }

    function update() {
      var value = currentStyleValue();
      var frames = preview.querySelectorAll('[data-acumen-style-frame]');
      var matched = false;
      for (var i = 0; i < frames.length; i++) {
        var v = frames[i].getAttribute('data-acumen-style-frame');
        var isMatch = v === value;
        frames[i].hidden = !isMatch;
        if (isMatch) matched = true;
      }
      // If nothing matched (no selection yet), show the first frame
      // as a default preview so the panel isn't empty on page load.
      if (!matched && frames.length) frames[0].hidden = false;
    }

    // Try to place immediately; if BCPO hasn't rendered yet, poll a few
    // times before giving up. Also re-run once BCPO settles via a
    // MutationObserver on the buy zone.
    var attempts = 0;
    var t = setInterval(function () {
      if (place() || ++attempts >= 30) {
        clearInterval(t);
        if (attempts < 30) update();
      }
    }, 300);

    // Any change inside the TIMBER STYLE wrapper counts — covers radios,
    // checkboxes AND selects (whose 'change' target won't be name="name2").
    scope.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.name === 'name2') { update(); return; }
      var wrap = findStyleVariantWrap();
      if (wrap && wrap.contains(e.target)) { setTimeout(update, 30); return; }
      // A select whose surrounding label reads "Timber Style" — native
      // Impulse selector, no data-unique tag on the wrapper.
      var host = e.target.closest && e.target.closest('.selector-wrapper, .variant-wrapper, .product-form__item, [data-variant-input]');
      if (host && /timber\s*style/i.test(host.textContent || '')) setTimeout(update, 30);
    }, true);
    scope.addEventListener('click', function (e) {
      var lbl = e.target && e.target.closest && e.target.closest('label');
      if (!lbl) return;
      var input = lbl.querySelector('input[name="name2"]');
      if (input) setTimeout(update, 30);
    });
    // Native Shopify variant swap — fires on select/radio changes both.
    document.addEventListener('variant:change', function () { setTimeout(update, 30); });
  }

  // ─────────── BCPO .bcpo-value surcharge visibility ───────────
  // BCPO renders both the selected-value echo (e.g. "150cm") AND the
  // price-add-on notice (e.g. "Custom RAL (+ £100.00)") into the same
  // .bcpo-value element next to each option title. The restyle hides
  // .bcpo-value by default so labels stay clean — but that also hides
  // the surcharge, which the customer MUST see. This scanner re-marks
  // any .bcpo-value whose text contains a currency character so it
  // stays visible; matching CSS makes the marker visible.
  function refreshBcpoSurcharges(scope) {
    if (!scope) return;
    // Currency indicator = £, $, €, ¥, or "+ <digit>" ("+ 100.00" etc.)
    var CURRENCY_RE = /[£$€¥]|\+\s*\d/;
    var nodes = scope.querySelectorAll('#bcpo .bcpo-value');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = (el.textContent || '').trim();
      var hasCurrency = CURRENCY_RE.test(text);
      // The base rule hides .bcpo-value; we tag currency-bearing ones so
      // CSS re-shows them AND we mirror the text into the sibling title
      // so it renders left-aligned next to "LEG FINISH:" rather than
      // wherever the row's flex layout pushes the raw value element.
      var wrap = el.closest('.selector-wrapper');
      var title = wrap && wrap.querySelector('.bcpo-title');
      // Find (or create) an inline surcharge span inside the title.
      var mirror = title && title.querySelector('[data-acumen-surcharge-mirror]');
      if (hasCurrency) {
        el.setAttribute('data-acumen-surcharge', '');
        if (title) {
          if (!mirror) {
            mirror = document.createElement('span');
            mirror.setAttribute('data-acumen-surcharge-mirror', '');
            title.appendChild(mirror);
          }
          // Keep text in sync — BCPO updates .bcpo-value as selections change.
          if (mirror.textContent !== ' ' + text) {
            mirror.textContent = ' ' + text;
          }
        }
      } else {
        if (el.hasAttribute('data-acumen-surcharge')) el.removeAttribute('data-acumen-surcharge');
        if (mirror && mirror.parentNode) mirror.parentNode.removeChild(mirror);
      }
    }
  }

  function wireBcpoValueVisibility(scope) {
    // Initial pass — BCPO may inject the surcharge after mount.
    var runs = 0;
    var t = setInterval(function () {
      refreshBcpoSurcharges(scope);
      if (++runs >= 15) clearInterval(t);
    }, 400);
    // Re-scan whenever any option changes.
    scope.addEventListener('change', function () {
      // Give BCPO a tick to update its labels first.
      setTimeout(function () { refreshBcpoSurcharges(scope); }, 40);
    }, true);
    scope.addEventListener('click', function () {
      setTimeout(function () { refreshBcpoSurcharges(scope); }, 40);
    }, true);
    // Also watch DOM mutations inside BCPO for late injections.
    var bcpo = scope.querySelector('#bcpo');
    if (bcpo && typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        clearTimeout(wireBcpoValueVisibility._d);
        wireBcpoValueVisibility._d = setTimeout(function () {
          refreshBcpoSurcharges(scope);
        }, 40);
      });
      mo.observe(bcpo, { childList: true, subtree: true, characterData: true });
    }
  }

  // ─────────── Leaf-assembly video modal ───────────
  // BCPO renders the "REQUIRE EXTENDABLE LEAFS?" question as radio buttons.
  // On pine products the option's data-unique is _fty5kjztx, on elm it's
  // _elmleaf. Both expose the same YES/NO values. When the customer picks
  // YES we open the assembly video modal so they see the mechanism before
  // they commit to the leaf up-charge. Only fires on the YES→NO transition
  // once per PDP session to avoid re-opening on unrelated form re-renders.
  // ─────────── Leaf-size validator ───────────
  // Business rule: the table's MAX extended length depends on timber.
  //   Reclaimed Elm  → 300cm (limited by board length in the salvage lot)
  //   Rustic Pine    → 400cm (newly-milled boards, no board-length ceiling)
  // Leaves live on BOTH ends so total added length = 2 × single-leaf. Each
  // leaf option in BCPO reads as "2 x <leaf>*<width>cm (+<added>cm Length)".
  // We disable any option that would push the table past the cap for the
  // current timber, or whose width doesn't match the customer's TABLE WIDTH
  // pick. If the currently-picked option becomes invalid we snap the
  // dropdown to the first valid one.
  // Static seed list. Every BCPO option's unique varies per product, so the
  // helper below extends this list on the fly by scanning the DOM for the
  // LEAF SIZE'S wrapper by its title text — no hardcoding per-PDP.
  var LEAF_SIZE_UNIQUES = ['_6qa3czpw1', '_6qa3czpw1_elm'];

  function discoverLeafSizeUniques() {
    // BCPO renders each option inside a wrapper with data-unique + a
    // .bcpo-title span for the label. Match on the LEAF SIZE'S title
    // (case-insensitive, apostrophe-tolerant).
    var seen = {};
    for (var i = 0; i < LEAF_SIZE_UNIQUES.length; i++) seen[LEAF_SIZE_UNIQUES[i]] = 1;
    var wraps = document.querySelectorAll('#bcpo [data-unique] .bcpo-title, [data-unique] .bcpo-title');
    for (var j = 0; j < wraps.length; j++) {
      var title = String(wraps[j].textContent || '').trim().toLowerCase();
      if (title.indexOf('leaf size') !== 0) continue; // "LEAF SIZE" / "LEAF SIZE'S" / "LEAF SIZES"
      var wrap = wraps[j].closest('[data-unique]');
      if (!wrap) continue;
      var u = wrap.getAttribute('data-unique');
      if (u && !seen[u]) {
        LEAF_SIZE_UNIQUES.push(u);
        seen[u] = 1;
      }
    }
  }
  var TIMBER_MAX_TOTAL = { elm: 300, pine: 400 };
  var TIMBER_MAX_TOTAL_FALLBACK = 400; // permissive (pine) default when we can't detect timber

  function getTimberMaxTotal() {
    // 1. Chip picker exposes the active timber on both pine and elm PDPs.
    var chip = document.querySelector('[data-acumen-timber-picker] .acumen-timber-chip.is-active[data-timber]');
    if (chip) {
      var t = String(chip.getAttribute('data-timber') || '').toLowerCase();
      if (TIMBER_MAX_TOTAL[t]) return TIMBER_MAX_TOTAL[t];
    }
    // 2. Size chart modal carries the raw metafield value (elm PDPs only today).
    var modal = document.querySelector('[data-acumen-sizechart-modal][data-timber-type]');
    if (modal) {
      var mt = String(modal.getAttribute('data-timber-type') || '').toLowerCase();
      if (mt.indexOf('elm') !== -1) return TIMBER_MAX_TOTAL.elm;
      if (mt.indexOf('pine') !== -1) return TIMBER_MAX_TOTAL.pine;
    }
    return TIMBER_MAX_TOTAL_FALLBACK;
  }

  function parseFirstNumber(s) {
    var m = String(s || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }
  function parseLeafOption(label) {
    // "2 x 30*110cm (+60cm Length)" → { leaf:30, width:110, added:60 }
    var m = String(label || '').match(/2\s*x\s*(\d+)\s*\*\s*(\d+)\s*cm\s*\(\+\s*(\d+)\s*cm/i);
    if (!m) return null;
    return { leaf: +m[1], width: +m[2], added: +m[3] };
  }
  function currentTableDim(uniqueDataAttr) {
    var wrap = document.querySelector('[data-unique="' + uniqueDataAttr + '"]');
    if (!wrap) return null;
    var sel = wrap.querySelector('select');
    if (sel && sel.value) return parseFirstNumber(sel.value);
    var chk = wrap.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (chk) return parseFirstNumber(chk.value);
    return null;
  }

  function ensureHint(wrap) {
    if (!wrap) return null;
    var hint = wrap.querySelector('[data-acumen-leaf-hint]');
    if (hint) return hint;
    hint = document.createElement('div');
    hint.setAttribute('data-acumen-leaf-hint', '');
    hint.className = 'acumen-leaf-size-hint';
    // Insert after the title, before the select
    var title = wrap.querySelector('.bcpo-title');
    if (title && title.parentNode === wrap) {
      title.insertAdjacentElement('afterend', hint);
    } else {
      wrap.insertBefore(hint, wrap.firstChild);
    }
    return hint;
  }

  function refreshLeafOptions() {
    // Discover any additional LEAF SIZE'S wrappers whose data-unique differs
    // from the seed list (varies per product).
    discoverLeafSizeUniques();
    // TABLE LENGTH is Shopify variant option 0 → BCPO data-unique="_0d4efab44"
    // TABLE WIDTH  is Shopify variant option 1 → BCPO data-unique="1"
    var tableLen = currentTableDim('_0d4efab44');
    var tableWid = currentTableDim('1');
    if (tableLen == null) return;
    var maxTotal = getTimberMaxTotal();
    var headroom = maxTotal - tableLen;
    var mathMaxPerLeaf = Math.max(0, Math.floor(headroom / 2));

    for (var i = 0; i < LEAF_SIZE_UNIQUES.length; i++) {
      var wrap = document.querySelector('[data-unique="' + LEAF_SIZE_UNIQUES[i] + '"]');
      if (!wrap) continue;
      var sel = wrap.querySelector('select');
      if (!sel) continue;

      // Find the largest leaf we actually offer for the current width — cap
      // the hint to that so we don't imply we sell (e.g.) 75cm leaves.
      var largestOffered = 0;
      for (var jj = 0; jj < sel.options.length; jj++) {
        var s0 = parseLeafOption(sel.options[jj].textContent || sel.options[jj].value);
        if (s0 && (tableWid == null || s0.width === tableWid) && s0.leaf > largestOffered) {
          largestOffered = s0.leaf;
        }
      }
      var maxPerLeaf = Math.min(mathMaxPerLeaf, largestOffered);

      var firstValid = null;
      for (var j = 0; j < sel.options.length; j++) {
        var opt = sel.options[j];
        var spec = parseLeafOption(opt.textContent || opt.value);
        if (!spec) {
          // "Not Required" or any non-leaf value — always valid.
          opt.disabled = false;
          opt.removeAttribute('data-acumen-invalid');
          if (firstValid == null) firstValid = opt;
          continue;
        }
        var widthOk  = (tableWid == null) || (spec.width === tableWid);
        var lengthOk = (tableLen + spec.added) <= maxTotal;
        var ok = widthOk && lengthOk;
        opt.disabled = !ok;
        if (ok) {
          opt.removeAttribute('data-acumen-invalid');
          if (firstValid == null || firstValid.value === '' || /Not Required/i.test(firstValid.textContent)) {
            // Prefer a real leaf over "Not Required" as fallback where possible.
            if (firstValid == null) firstValid = opt;
          }
        } else {
          opt.setAttribute('data-acumen-invalid', '');
        }
      }

      // If the currently selected option is now disabled, revert to the
      // first valid one (usually "Not Required") and fire change so any
      // dependent instruction blocks re-evaluate.
      var current = sel.options[sel.selectedIndex];
      if (current && current.disabled) {
        // Prefer "Not Required" if present, else first valid.
        var notRequired = null;
        for (var k = 0; k < sel.options.length; k++) {
          if (/Not Required/i.test(sel.options[k].textContent)) { notRequired = sel.options[k]; break; }
        }
        var fallback = notRequired || firstValid;
        if (fallback) {
          sel.value = fallback.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Update the hint text
      var hint = ensureHint(wrap);
      if (hint) {
        if (maxPerLeaf <= 0) {
          hint.textContent = 'This table is already at our maximum length (' + maxTotal + 'cm). Extendable leaves are not available at ' + tableLen + 'cm.';
          hint.setAttribute('data-max', '0');
        } else {
          hint.textContent = 'Max leaf size for a ' + tableLen + 'cm table: ' + maxPerLeaf + 'cm each end (' + maxTotal + 'cm cap when fully extended).';
          hint.setAttribute('data-max', String(maxPerLeaf));
        }
      }
    }
  }

  function wireLeafSizeValidator(scope) {
    refreshLeafOptions();
    // Re-run on any change (variant flip, leaf YES/NO, dropdown pick).
    scope.addEventListener('change', function () { setTimeout(refreshLeafOptions, 60); }, true);
    scope.addEventListener('click', function () { setTimeout(refreshLeafOptions, 80); }, true);
    document.addEventListener('variant:change', function () { setTimeout(refreshLeafOptions, 60); });
    // Poll a few times to catch BCPO's late renders when the customer
    // first flips REQUIRE EXTENDABLE LEAFS from NO to YES.
    var ticks = 0;
    var t = setInterval(function () {
      refreshLeafOptions();
      if (++ticks >= 30) clearInterval(t);
    }, 400);
    // Also watch for DOM mutations in #bcpo (dropdown re-render on option toggle).
    var bcpo = document.getElementById('bcpo');
    if (bcpo && typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        clearTimeout(wireLeafSizeValidator._d);
        wireLeafSizeValidator._d = setTimeout(refreshLeafOptions, 60);
      });
      mo.observe(bcpo, { childList: true, subtree: true });
    }
  }

  var LEAF_OPTION_UNIQUES = ['_fty5kjztx', '_elmleaf'];
  function wireLeafVideo(scope) {
    var modal = document.querySelector('[data-acumen-leaf-video-modal]');
    if (!modal) return;
    var frame   = modal.querySelector('[data-acumen-leaf-video-frame]');
    var closeBtn = modal.querySelector('[data-acumen-leaf-video-close]');
    var ytId    = modal.getAttribute('data-yt-id') || '';
    if (!ytId || !frame) return;

    // Seed list of known BCPO uniques for the leaf-image collage. The
    // helper below extends it on the fly by scanning the DOM for any BCPO
    // wrapper that hosts a leaf-related image — the unique varies per
    // product (e.g. Grisedale = _urojpbc18, others = _xtv5wv0ep) and
    // BCPO's YES/NO gate controls its visibility.
    var LEAF_IMAGE_UNIQUES = ['_xtv5wv0ep', '_xtv5wv0ep_elm'];
    var LEAF_IMAGE_URL_RE  = /leaf_extension|leaf_assembly|leaf-extension|leaf-assembly|leafs?_v\d/i;
    var LINK_LABEL = 'Watch Leaf Assembly Video';

    function discoverLeafImageUniques() {
      var seen = {};
      for (var i = 0; i < LEAF_IMAGE_UNIQUES.length; i++) seen[LEAF_IMAGE_UNIQUES[i]] = 1;
      // Any <img> whose src looks leaf-y — walk up to its [data-unique]
      // wrapper, which is the BCPO instruction block hosting the collage.
      var imgs = document.querySelectorAll('#bcpo img, [data-unique] img');
      for (var j = 0; j < imgs.length; j++) {
        var src = imgs[j].getAttribute('src') || '';
        if (!LEAF_IMAGE_URL_RE.test(src)) continue;
        var wrap = imgs[j].closest('[data-unique]');
        if (!wrap) continue;
        var u = wrap.getAttribute('data-unique');
        if (u && !seen[u]) { LEAF_IMAGE_UNIQUES.push(u); seen[u] = 1; }
      }
    }

    function open() {
      // Build the iframe fresh each open so autoplay works and the video
      // restarts. Using youtube-nocookie keeps privacy tidy.
      var url = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytId) +
                '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      frame.innerHTML = '<iframe src="' + url + '" title="Extension leaves — assembly demo" ' +
                        'frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" ' +
                        'allowfullscreen loading="eager"></iframe>';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      // Wipe the iframe so playback and audio actually stop — a hidden
      // iframe keeps playing behind the modal otherwise.
      frame.innerHTML = '';
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    // Explicit-trigger model (replaced auto-popup on YES which felt intrusive):
    // inject a "Watch Leaf Assembly Video" link inside each leaf-image
    // instruction block. BCPO shows/hides these blocks based on the YES/NO
    // radio state, so the link naturally appears only when the customer is
    // engaging with the leaf collage.
    function injectLinks() {
      discoverLeafImageUniques();
      for (var i = 0; i < LEAF_IMAGE_UNIQUES.length; i++) {
        var host = document.querySelector('[data-unique="' + LEAF_IMAGE_UNIQUES[i] + '"]');
        if (!host) continue;
        if (host.querySelector('[data-acumen-leaf-video-open]')) continue;
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'acumen-leaf-video-link';
        a.setAttribute('data-acumen-leaf-video-open', '');
        a.innerHTML = '<span class="acumen-leaf-video-link__icon" aria-hidden="true">▶</span>' +
                      '<span class="acumen-leaf-video-link__label">' + LINK_LABEL + '</span>';
        host.appendChild(a);
      }
    }

    // Run repeatedly to catch BCPO's late renders (option shows/hides on radio change).
    injectLinks();
    var poll = setInterval(injectLinks, 500);
    setTimeout(function () { clearInterval(poll); }, 8000);
    // Re-run whenever BCPO rerenders (any option change re-emits DOM).
    scope.addEventListener('change', function () { setTimeout(injectLinks, 60); }, true);

    // Delegated click handler for the link (survives BCPO re-renders).
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-acumen-leaf-video-open]');
      if (!trigger) return;
      e.preventDefault();
      open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  // ─────────── Init ───────────
  function init() {
    var scope = document.querySelector('.acumen-pdp-scope');
    if (!scope) {
      // Pages outside the table template (e.g. shelves) can opt into just the sticky add-to-cart bar.
      var stickyOnly = document.querySelector('[data-acumen-sticky-only]');
      if (stickyOnly) wireStickyAtc(stickyOnly);
      return;
    }

    updateSeatBadge(scope);
    wireSizeChart(scope);
    wireBcpoValueVisibility(scope);
    wireTimberStylePreview(scope);
    wireLeafVideo(scope);
    wireLeafSizeValidator(scope);
    wireDesignCta(scope);
    wireStickyAtc(scope);
    watchExtrasPosition(scope);
    watchTimberPicker();

    // Re-run the seat estimator on any variant change signal.
    scope.addEventListener('change', function () { updateSeatBadge(scope); });
    document.addEventListener('variant:change', function () { updateSeatBadge(scope); });
  }

  ready(init);
})();
